import { Button, primary2, white, tertiary2_60 } from "@shane-collective/design-system";
import { useState } from "react";

interface Props {
  onButtonPress: () => void;
  isSmallScreen : boolean;
}

export const SearchThisAreaButton: React.FC<Props> = ({ onButtonPress, isSmallScreen }) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  return (
    <div
      style={{
        backgroundColor: isHovered ? primary2 : tertiary2_60,
        borderRadius: "20px",
        position: isSmallScreen ? "relative" :"fixed",
        top: isSmallScreen ? 0 : 60,
        left: isSmallScreen ? 'unset' : "50%",
        transform: isSmallScreen ? 'unset' : `translateX(-50%)`,
        zIndex: 998,
        paddingLeft: "20px",
        paddingRight: "20px",
        textAlign: "center",
        height: "30px",
        cursor: "pointer", // Cursor pointer on hover to indicate it's clickable
        transition: "background-color 0.3s, transform 0.1s", // Smooth transition for hover and click effects
      }}
      onMouseEnter={() => setIsHovered(true)} // When mouse enters
      onMouseLeave={() => setIsHovered(false)} // When mouse leaves
    >
      <Button
        type="link"
        onPress={onButtonPress}
        labelColor={isHovered ? white : primary2}
        label="Search this area"
        aria-label="Search this area"
      />
    </div>
  );
};
